import { flexCenterSx, marginTop24Sx } from '../../styles/Global.style';

export const toggleSwitchContainerSx = {
  ...flexCenterSx,
  ...marginTop24Sx,
};

export const distanceInputAdornmentSx = (theme) => ({
  '.MuiTypography-root': {
    color: theme.palette.secondary.main,
  },
});

export const moodCheckSx = (theme) => ({
  border: `1px solid ${theme.palette.secondary.main}`,
});
